var ParameterInfo = /** @class */ (function () {
    function ParameterInfo(abc, type, 
    /**
   * Don't rely on the name being correct.
   */
    name, optionalValueKind, optionalValueIndex) {
        this.abc = abc;
        this.type = type;
        this.name = name;
        this.optionalValueKind = optionalValueKind;
        this.optionalValueIndex = optionalValueIndex;
        // ...
    }
    ParameterInfo.prototype.getName = function () {
        if (typeof this.name === 'number') {
            this.name = this.abc.getString(this.name);
        }
        return this.name;
    };
    ParameterInfo.prototype.getType = function () {
        if (typeof this.type === 'number') {
            this.type = this.abc.getMultiname(this.type);
        }
        return this.type;
    };
    ParameterInfo.prototype.hasOptionalValue = function () {
        return this.optionalValueKind >= 0;
    };
    ParameterInfo.prototype.getOptionalValue = function () {
        return this.abc.getConstant(this.optionalValueKind, this.optionalValueIndex);
    };
    ParameterInfo.prototype.toString = function () {
        var str = '';
        if (this.name) {
            str += this.getName();
        }
        else {
            str += '?';
        }
        if (this.type) {
            str += ': ' + this.getType().name;
        }
        if (this.optionalValueKind >= 0) {
            str += ' = ' + this.abc.getConstant(this.optionalValueKind, this.optionalValueIndex);
        }
        return str;
    };
    return ParameterInfo;
}());
export { ParameterInfo };
